import React, { useEffect } from 'react';
import { FieldProps } from '@rjsf/core';
import { useSelectCountry } from './hooks/useSelectCountry';
import { languages, Language } from 'countries-list'
import { LangPropType } from './SelectCountry';

export const SelectLanguage: React.FC<FieldProps> = (props: FieldProps) => {

    const {
        renderCombo,
        setOptions,
    } = useSelectCountry(props)

    useEffect(() => {
        setOptions(getOptions())
    }, [props.formData])

    const getOptions = (): Array<LangPropType> => {
        const options = languages as Record<string, Language>
        return Object.keys(options).map((item: string, key: number) => ({
            name: options[item].name,
            code: item.toUpperCase()
        }))
    }
    
    return renderCombo()
}